import { fetchWithAuth } from '../auth/authService';

export const getPolicyService = async (type) => {
  const response = await fetchWithAuth(`/api/Policy/GetPolicy?type=${encodeURIComponent(type)}`, {
    method: 'GET',
  });

  return response; // fetchWithAuth already calls handleResponse
};
